var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"c-rating"},[_c('img',{attrs:{"src":_vm.rating,"width":_vm.size}})])
}
var staticRenderFns = []

export { render, staticRenderFns }